import styled from 'styled-components';

import { color } from '../../../atoms/colors';
import { font } from '../../../atoms/typography';
import { atMinWidth } from '../../../atoms/breakpoints';
import { spacing } from '../../../atoms/spacing';
import { containers } from '../../../atoms/containers';

export const Section = styled.section`
  width: 100%;
  padding: ${spacing[100]} 0px ${spacing[48]};
  background-color: ${color.green[25]};

  ${atMinWidth.sm`
    padding: ${spacing[100]} 0px ${spacing[64]};
  `}

  ${atMinWidth.xl`
    padding: ${spacing[112]} 0px ${spacing[64]};
  `}
`;

export const Wrapper = styled.div`
  width: 100%;
  max-width: ${containers.md};
  display: flex;
  flex-direction: column;
  gap: ${spacing[32]};
  padding: ${spacing[0]} ${spacing[16]};
  margin: ${spacing[0]} auto;

  ${atMinWidth.sm`
    padding: ${spacing[0]} ${spacing[32]};
  `}

  ${atMinWidth.xl`
    max-width: ${containers.xl};
  `}
`;

export const Container = styled.div`
  width: 100%;
  max-width: 800px;
  display: flex;
  flex-direction: column;
  gap: ${spacing[24]};

  .heading {
    ${font('display', 'md', '500')}

    ${atMinWidth.xl`
      ${font('display', 'lg', '500')}
    `}
  }
`;

export const Categories = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: ${spacing[12]};

  ${atMinWidth.sm`
    gap: ${spacing[16]};
  `}
`;

export const Button = styled.button`
  border-color: ${color.common.transparent};
  background-color: ${color.common.transparent};
  outline: none;
`;
